// Angular dependencies
import {
  Component,
  Input,
  ViewChild,
  ElementRef
} from '@angular/core';

import {
  CREEP_OPERATOR,
  CREEP_COMMANDER,
  CREEP_EXECUTOR
} from '../../creep/creep.enum';

import { Creep } from '../../creep/creep';
import { Skill } from '../../creep-skill';

@Component({
  selector: 'app-creep',
  templateUrl: './creep.component.html',
  styleUrls: ['./creep.component.scss']
})
export class CreepComponent {
  @Input() creep: Creep;
  @ViewChild('inputCreepName') inputCreepName: ElementRef;

  public isEditName = false;

  constructor(
  ) {
  }

  get skills(): Skill[] {
    return this.creep.skills.toArray();
  }

  startEditName() {
    this.isEditName = true;

    setTimeout(() => {
      this.inputCreepName.nativeElement.focus();
    });
  }

  stopEditName() {
    this.isEditName = false;
  }

  isOperator(): boolean {
    return this.creep.type === CREEP_OPERATOR;
  }

  isCommander(): boolean {
    return this.creep.type === CREEP_COMMANDER;
  }

  idExecutor(): boolean {
    return this.creep.type === CREEP_EXECUTOR;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/creep.component/creep.component.ts